import { useEffect } from "react";

// Locks the page while an overlay/popup is open:
// - pauses Lenis smooth-scroll (otherwise it hijacks wheel/touch and the
//   overlay's own scroll container never receives the events)
// - prevents the background body from scrolling
//
// Note: the scrollable element inside the overlay must also carry the
// `data-lenis-prevent` attribute so Lenis ignores native scrolling there.
export const useScrollLock = (active) => {
  useEffect(() => {
    if (!active) return;

    const lenis = window.__lenis;
    lenis?.stop();

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
      lenis?.start();
    };
  }, [active]);
};
